import React, { useCallback, useMemo, useState } from 'react';
import { useGetTimeSignalUtilizationAnalyticsData } from 'modules/Insights/Notes/hooks/useGetTimeSignalUtilizationAnalytics';
import { useNoteInsightsContext } from 'modules/Insights/Notes/NoteInsightsContextProvider';
import MyUtilizationChart from './MyUtilizationChart';
import { transformUtilzationAnalyticsData } from './utils';

const UserUtilizationChart: React.FC = () => {
  const [checked, setChecked] = useState(false);

  const {
    data: rData,
    loading,
    isEmpty
  } = useGetTimeSignalUtilizationAnalyticsData();
  const { currentPeriod, selectedViewOption } = useNoteInsightsContext();
  const tData = useMemo(
    () => transformUtilzationAnalyticsData(rData, checked, currentPeriod),
    [checked, currentPeriod, rData]
  );

  const handleCheckBoxChange = useCallback((event) => {
    setChecked(event.target.checked);
  }, []);

  return (
    <>
      <MyUtilizationChart
        tData={tData}
        checked={checked}
        handleCheckBoxChange={handleCheckBoxChange}
        loading={loading}
        isEmpty={isEmpty}
        selectedViewOption={selectedViewOption}
      />
    </>
  );
};

export default React.memo(UserUtilizationChart);
